import { Directive, HostListener } from '@angular/core'

@Directive({
  selector: '[isFocusing]',
  exportAs: 'isFocusing',
  standalone: false,
})
export class IsFocusingDirective {
  isFocusing = false

  @HostListener('mouseenter') onMouseEnter() {
    this.isFocusing = true
  }

  @HostListener('mouseleave') onMouseLeave() {
    this.isFocusing = false
  }

  constructor() {}
}
